var map = {
	"./6512efd054aa45b8b937b9d001a630c7_mergeImage.png": "ff1e",
	"./736d446c357d41598844661522e89483_mergeImage.png": "bf74",
	"./7820290100c74681b8e3ff6224ccc640_mergeImage.png": "4d23",
	"./FigmaDDSSlicePNG03916dc42b7c22b5ec14e56013ec1349.png": "a9d5",
	"./FigmaDDSSlicePNG15d964e6f3fbac6710bc548860c8a086.png": "5d21",
	"./FigmaDDSSlicePNG1c16732bee3eda6661273be438b1d45e.png": "afbb",
	"./FigmaDDSSlicePNG1d06d74ac44fc08855c08cfb9b2629d0.png": "1302",
	"./FigmaDDSSlicePNG2c94e88e533ab081e15e88171935f0e1.png": "3ce0",
	"./FigmaDDSSlicePNG34d4817729486aba01bd41c4cbe44fcf.png": "8e83",
	"./FigmaDDSSlicePNG38c26e22d5add62b09c33d4fcf9f6a90.png": "14c8",
	"./FigmaDDSSlicePNG38dcd981f4fb22962fdda5f0d84da6be.png": "8e8b",
	"./FigmaDDSSlicePNG4eedcbfd5e10232e472a00126889ff55.png": "a17f",
	"./FigmaDDSSlicePNG52b7ae90752611adf000da424a858ee2.png": "420a",
	"./FigmaDDSSlicePNG542abf17f1f0d6539bb2e040dc64f4e7.png": "3448",
	"./FigmaDDSSlicePNG7d99ebe8499022a158510f0ddace5cad.png": "e9cd",
	"./FigmaDDSSlicePNG7dd549fb11643e7d311af2637e58f330.png": "37b8",
	"./FigmaDDSSlicePNG8c769677dc67bc14ff44684e7629456d.png": "80c3",
	"./FigmaDDSSlicePNG92969c37e2f9890cc51eb4b616c7fceb.png": "b344",
	"./FigmaDDSSlicePNG960f2ac6972d30d4159a696810acec76.png": "796b",
	"./FigmaDDSSlicePNG9d22163c6c8103931492b656e8330ea8.png": "4ffa",
	"./FigmaDDSSlicePNGa2c5eeaf8e67b6f8c31a516a6c43f117.png": "876a",
	"./FigmaDDSSlicePNGa3f6ca8b88ac61da157398fc983123aa.png": "a353",
	"./FigmaDDSSlicePNGaeb2461d70e415ff66a2250b7020727e.png": "c17d",
	"./FigmaDDSSlicePNGb212023b2c0c6c18e49d7afd472dbd20.png": "75f9",
	"./FigmaDDSSlicePNGb71cbec75df2be26ef1132a831c3d42c.png": "775a",
	"./FigmaDDSSlicePNGcbee947f362182dfa9eeabdf7688e5b3.png": "0073",
	"./FigmaDDSSlicePNGd616238e97d1ddc731b629d1149ca237.png": "4432",
	"./FigmaDDSSlicePNGdd1cbdf006a7c51b8301a68adc7ae39b.png": "8cad",
	"./FigmaDDSSlicePNGdfa5c4bfbbdbdada11b706e24ace263c.png": "63d4",
	"./FigmaDDSSlicePNGe1c2884bb137e0987da286949c5029de.png": "da17",
	"./FigmaDDSSlicePNGe33a219e051a93b05a0120edae93dedf.png": "8a7f",
	"./FigmaDDSSlicePNGe484cf7ce4ae3d2890837c7651d63ec1.png": "ee7d",
	"./FigmaDDSSlicePNGe5a2d2d1c5187a9e1f45b64d95e7119f.png": "f12f",
	"./FigmaDDSSlicePNGe6a8a6b1470ed19dc8f309c79ce746ce.png": "a044",
	"./FigmaDDSSlicePNGfeb2a57d0b372f82d90e9287201849ba.png": "1c49"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79ca";